module.exports = __webpack_public_path__ + "static/ilustrator-a6fff563a1f339c8b8d8e0c0ac6ba772.svg";